export const SESSION_KEY = {
  // 一覧系画面の送料無料＋支払方法ロゴ枠の閉じる動作用
  HAS_CLOSED_PROMO: 'has_closed_promo',
};
